//-- Copyright (c) 2021 TMT Insights Group, LLC
import { DataTableConfig } from '@/__configs/config_types';
import { useAppSelector } from '@/redux/hooks';
import { selectCanAddAssemblyTemplates } from '@/redux/selectors/authSelectors';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import { Grid } from '@mui/material';
import { dataTableInitialState } from '../../redux/selectors/configSelectors';
import { Title, TitleBar } from '../_common';
import AssemblyTemplateActionButton from '../Packaging/AssemblyTemplateActionButton';

const AssemblyTemplatesTitleBar = () => {
  const tableName = useAppSelector(selectCurrentTableKey);
  const title = dataTableInitialState[tableName as keyof DataTableConfig]?.title;
  const canAddAssemblyTemplates = useAppSelector(selectCanAddAssemblyTemplates);

  return (
    <TitleBar>
      <Grid container justifyContent="space-between" alignItems="center">
        <Title>{title || 'Assembly Templates'}</Title>
        {canAddAssemblyTemplates && <AssemblyTemplateActionButton creationMode="new" />}
      </Grid>
    </TitleBar>
  );
};

export default AssemblyTemplatesTitleBar;
